var SortedMap = require("../collections/sortedMap.js");
var sanityCheckHandler = require("../observable/sanityCheckHandler.js");

// Root extension to add undo / redo functionality
var Undoable = {
    makeUndoable: function(){
        console.assert(this.hasJsonParser, "Undoable root extension needs a json parser");

        this.historyLength = 20;
        this.recording = [];
        this.undoStack = [];
        this.redoStack = [];

        this._lockState = 0; // current lock state of the root: 0 = not locked, 1 = only next action is allowed, following are not, 2 = locked (no changes allowed);

        this.handlers.action = new SortedMap();

        this.isUndoable = true;
    },

    rec: function(){ // TODO: maybe eliminate rec, you only need a finishAction command
        // this.onBubble("__record", this.recordEvent); // TODO: this should be set once on init!
        if(this._logging)
            console.warn("Warning: recording is already on");
        this._logging = true;
    },

    pauseRec: function(){
        // this.handlers.bubble.remove("__record");
        this._logging = false;
    },

    isRecording: function(){
        // return this.handlers.bubble.contains("__record");
        return this._logging;
    },

    stopRec: function(){ // TODO: maybe rename into finishAction
        if(!this._logging)
            throw new Error("stopRec expects recording to be on");
        var self = this;
        this.pauseRec();    // TODO shouldn't automatically stop recording events in datatree, possible pitfall is that you miss events and hence you cannot undo them
        var action = this.recording.map(function(event){ // jsonify all events in this action to avoid changes in recorded events due to retained object references
            // TODO: this should already happen in recordEvent! possible error: move a node from one parent to another in same recording => node will get a new id
            return self.jsonifyEvent(event);
        });
        if (action.length > 0){ // ignore empty actions
            if (this.undoStack.length == this.historyLength) this.undoStack.shift();
            this.undoStack.push(action);
            this.redoStack = [];
            this.recording = [];
            this.handlers.action.forEach(function(k, handler){
                handler.call(self, action, false);
            });
        }
    },

    cancelRec: function(){ // TODO: maybe rename into cancelAction
        this.pauseRec();
        for (var i = this.recording.length-1; i >= 0; i--){
            this._lockState = 1; // make sure only revert of event is executed, all coupled events are rejected
            this.recording[i].revert();
        }
        this.recording = [];
        this._lockState = 0;    // after cancel is finished, root is unlocked
    },

    isLocked: function(requestForAction){
        if (this._lockState == 0) return false;
        else if (this._lockState == 2) return true;
        else if (this._lockState == 1) {
            if (!requestForAction) return true; // asking for the root locking state out of interest when only 1 action is allowed (triggered by undo) return root is locked
            else {
                this._lockState = 2;
                return false;
            }
        }
    },

    undo: function(){
        var self = this;
        if(this._logging) this.stopRec(); // undo will automatically finish current recording action if there is some
        var action = this.undoStack.pop();
        if (action){
            this.rec();    // record reverted changes
            for (var i = action.length-1; i >= 0; i--){
                this._lockState = 1; // make sure only revert of event is executed, all coupled events are rejected
                this.dejsonifyEvent(action[i]).revert();
            }
            var revertedAction = this.recording.map(function(event){return self.jsonifyEvent(event)});
            this.recording = [];
            this._lockState = 0;    // after undo is finished, root is unlocked
            this.pauseRec();

            this.redoStack.push(action);
            this.handlers.action.forEach(function(k, handler){
                handler.call(self, revertedAction, false);
            });
        }
    },

    redo: function(){
        var self = this;
        if (this.recording.length > 0 || this.redoStack.length ==0) return;
        var action = this.redoStack.pop();
        if (action){
            for (var i = 0; i < action.length; i++){
                this._lockState = 1; // make sure only applied event is executed, all coupled events are rejected
                this.dejsonifyEvent(action[i]).reApply();
            }
            this._lockState = 0;    // after redo is finished, root is unlocked
            this.undoStack.push(action);
            this.handlers.action.forEach(function(k, handler){
                handler.call(self, action, false);
            });
        }
    },

    onFinishAction: function(key, handler, priority) {
        sanityCheckHandler(arguments);
        this.handlers.action.put(key, handler, priority || 0);
    },

    logEvent: function(event){  // TODO: try to use root bubble handlers again! when bubble order is fixed
        console.assert(this._logging || this._lockState > 0 || event.target.collection.nonPersistent, "Event (that was not caused by remote change) occurred outside recording");
        if (this._logging) this.recordEvent(event);
    },

    // Internal function
    recordEvent: function(event){ // TODO: not very efficient! worst case: O(2 * n * m) with n = number of previous events in this recording, m = depth in datatree => maybe do all or part of the event merge on finishAction
        if (event.target.collection.nonPersistent) return;  // ignore events in nonPersistent collections: TODO
        if (event.target.collection.getType() == "list") var listIdx = event.target.key;
        for (var i = this.recording.length-1; i >= 0; i--){
            var prevEvent = this.recording[i];

            // If another event has changed the same value: merge
            if (listIdx == undefined){
                if (event.target.collection == prevEvent.target.collection && event.target.key === prevEvent.target.key) {
                    if (event.value == prevEvent.oldValue) this.recording.splice(i, 1);
                    else {
                        prevEvent.type = event.type;
                        prevEvent.value = event.value;
                    }
                    return;
                }
            } else {
                if (event.target.collection == prevEvent.target.collection) {
                    if (listIdx === prevEvent.target.key){
                        if (event.type == "put" && (prevEvent.type == "put" || prevEvent.type == "add")) {
                            if (event.value == prevEvent.oldValue) this.recording.splice(i, 1); // if new value equals old value: cancel event
                            else prevEvent.value = event.value;
                            return;
                        } else if (event.type == "add" && prevEvent.type == "remove") {
                            if (event.value == prevEvent.oldValue) this.recording.splice(i, 1);
                            else {
                                prevEvent.type = "put";
                                prevEvent.value = event.value;
                                i++;
                            }
                            for (i; i < this.recording.length; i++) {
                                if (this.recording[i].target.collection == event.target.collection) {
                                    if (this.recording[i].target.key >= listIdx) this.recording[i].target.key++;
                                    if (this.recording[i].target.key <= listIdx) {
                                        if (this.recording[i].type == "add") listIdx++;
                                        else if (this.recording[i].type == "remove") listIdx--;
                                    }
                                }
                            }
                            return;
                        } else if (event.type == "remove" && (prevEvent.type == "put" || prevEvent.type == "add")) {
                            if (event.value == prevEvent.oldValue) this.recording.splice(i, 1);
                            else {
                                prevEvent.type = "remove";
                                prevEvent.value = event.value;
                                i++;
                            }
                            for (i; i < this.recording.length; i++) {
                                if (this.recording[i].target.collection == event.target.collection && this.recording[i].target.key >= listIdx) this.recording[i].target.key--;
                            }
                            return;
                        }
                    }
                    if (prevEvent.target.key <= listIdx) {
                        if (prevEvent.type == "add") listIdx--;
                        else if (prevEvent.type == "remove") listIdx++;
                    }
                }
            }

            // if something has already changed to some parent: merge changes in parent change
            if (prevEvent.target.collection.isOwner() && (event.target.node == prevEvent.value || event.target.node.isChildOf(prevEvent.value))) return;

            // if this event encapsulates previous event (can happen when dataHandler changes something to one of it's children), merge previous event in this one
            if (prevEvent.target.node == event.value || prevEvent.target.node.isChildOf(event.value)) this.recording.splice(i, 1);

            // if this event removes node of previous event, remove previous event
            if (event.oldValue && event.oldValue.isObservableTreeNode && event.target.collection.isOwner() && (prevEvent.target.node == event.oldValue || prevEvent.target.node.isChildOf(event.oldValue))){
                if (!event.oldValueJson) event.oldValueJson = this.jsonifyValue(event.oldValue, event.target.collection.isOwner());

                // include the previous event in the removal of this event: TODO: not very clean to directly change the json here!
                var jsonPath = this.jsonifyPath(prevEvent.target.node.getPath());
                var nodeJson = event.oldValueJson;
                for (var j=0; j<jsonPath.length; j++) nodeJson = nodeJson[jsonPath[j]];
                var prevEventJson = this.jsonifyEvent(prevEvent);
                if (prevEventJson[0] == "change"){
                    if (prevEvent[3] == undefined) nodeJson[prevEventJson[2]] = prevEventJson[5];
                    else nodeJson[prevEventJson[2]][prevEvent[3]] = prevEventJson[5];
                } else if (prevEventJson[0] == "insert") nodeJson[prevEventJson[2]].splice(prevEvent[3], 1);
                else if (prevEventJson[0] == "remove"){
                    var col = nodeJson[prevEventJson[2]];
                    if (Array.isArray(col)) col.splice(prevEventJson[3], 0, prevEventJson[5]);
                    else col[prevEventJson[3]] = prevEventJson[5];
                }

                this.recording.splice(i, 1);
            }
        }

        if (!event.oldValueJson) event.oldValueJson = this.jsonifyValue(event.oldValue, event.target.collection.isOwner());  // directly jsonify old value, TODO: maybe also already jsonify path
        this.recording.push(event);
    }
};

module.exports = Undoable;